import React, { createContext, useState } from 'react';

export const PartsContext = createContext();

export const PartsProvider = ({ children }) => {
  const [parts, setParts] = useState([]);
  const [currentItemIndex, setCurrentItemIndex] = useState(0);
  const [currentPartName, setCurrentPartName] = useState('');
  const [navigationHistory, setNavigationHistory] = useState([]);

  const addToNavigationHistory = (path) => {
    setNavigationHistory([...navigationHistory, path]);
  };

  const getLastPartPath = () => {
    for (let i = navigationHistory.length - 1; i >= 0; i--) {
      if (navigationHistory[i].startsWith('/parts/')) {
        return navigationHistory[i];
      }
    }
    return null;
  };

  return (
    <PartsContext.Provider value={{ 
      parts, setParts, 
      currentItemIndex, setCurrentItemIndex, 
      currentPartName, setCurrentPartName,
      addToNavigationHistory, getLastPartPath 
    }}>
      {children}
    </PartsContext.Provider>
  );
};
